import type { FC, HTMLAttributes } from 'react'

import { cn } from '@/utils'

import type { TodDisplayFormat } from '~shared/rundown/rundown'
import { formatTimeOfDay } from '~shared/timeutils'

interface GroupRangeProps extends HTMLAttributes<HTMLSpanElement> {
  start?: Date
  end?: Date
  timezone?: string | null
  separatorClassName?: string
  startClassName?: string
  endClassName?: string
  todDisplayFormat?: TodDisplayFormat | null
}

// formatTimeOfDay maps a null format to 24h, so only timezone needs a fallback.
export const GroupRange: FC<GroupRangeProps> = ({
  start,
  end,
  separatorClassName,
  startClassName,
  endClassName,
  todDisplayFormat,
  className,
  timezone,
  ...spanProps
}) => {
  if (!start || !end) return null

  const startTime = formatTimeOfDay(start, {
    format: todDisplayFormat,
    timezone: timezone ?? 'UTC',
  })
  const endTime = formatTimeOfDay(end, {
    format: todDisplayFormat,
    timezone: timezone ?? 'UTC',
  })

  return (
    <span
      className={cn('text-xs', className)}
      {...spanProps}
    >
      <span className={cn('tabular-nums', startClassName)}>{startTime}</span>{' '}
      <span className={separatorClassName}>→</span>{' '}
      <span className={cn('tabular-nums', endClassName)}>{endTime}</span>
    </span>
  )
}
